import React from 'react';

const HIDDEN_Y_PX = -40;
const DISPLACEMENT_Y_PX = 40;
const RADIUS = 20;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const ARC_SWEEP_DEG = 300;
const ARROW_START_AT = 0.1;

interface Props {
  progress: number;
  isRefreshing: boolean;
  isPulling: boolean;
}

export const PullToRefreshIndicator: React.FC<Props> = ({
  progress,
  isRefreshing,
  isPulling,
}) => {
  if (!progress) {
    return null;
  }

  const offsetY = HIDDEN_Y_PX + progress * (DISPLACEMENT_Y_PX - HIDDEN_Y_PX);
  const endAngle = progress * ARC_SWEEP_DEG;
  const endRadians = (endAngle * Math.PI) / 180;
  const arrowX = 50 + RADIUS * Math.cos(endRadians);
  const arrowY = 50 + RADIUS * Math.sin(endRadians);
  const arrowScale = Math.max(
    (progress - ARROW_START_AT) / (1 - ARROW_START_AT),
    0,
  );

  return (
    <div
      className="pointer-events-none absolute inset-x-0 top-0 z-20 flex justify-center md:hidden"
      style={{
        transform: `translateY(${offsetY}px)`,
        transition: isPulling ? 'none' : 'transform 200ms',
      }}
    >
      <span
        className="flex size-10 items-center justify-center rounded-full bg-card text-primary shadow-card"
        style={{ opacity: progress }}
      >
        <svg
          viewBox="22 22 56 56"
          className={`size-6 ${isRefreshing ? 'animate-spin' : ''}`}
        >
          <g transform="rotate(-90 50 50)">
            <circle
              cx="50"
              cy="50"
              r={RADIUS}
              fill="none"
              stroke="currentColor"
              strokeWidth="6"
              strokeLinecap="round"
              strokeDasharray={
                isRefreshing
                  ? undefined
                  : `${(endAngle / 360) * CIRCUMFERENCE} ${CIRCUMFERENCE}`
              }
              className={isRefreshing ? 'animate-refresh-arc' : ''}
            />
            {!isRefreshing && (
              <polygon
                points="0,-10 0,10 13,0"
                fill="currentColor"
                transform={`translate(${arrowX} ${arrowY}) rotate(${endAngle + 90}) scale(${arrowScale})`}
              />
            )}
          </g>
        </svg>
      </span>
    </div>
  );
};
